import { useMemo } from "react";
import { useSelector } from "react-redux";
import { useI18nContext } from "@hopper-b2b/i18n";
import { useCarAvailabilityLink } from "@tenant/cars";
import type { CarAvailabilityCardType } from "./CarAvailabilityCard";
import { CarsAvailabilitySelectors } from "~core-cars/store";
import {
  getBaggageQty,
  getVehicleClassLabelFromVehicle,
  getVehicleTransmissionLabel,
} from "~core-cars/utilities";

export const useCarAvailabilityCard = (props: CarAvailabilityCardType) => {
  const { car } = props;

  const { t } = useI18nContext();

  const searchDayCount = useSelector(
    CarsAvailabilitySelectors.getSearchDayCount
  );

  const { goToShop } = useCarAvailabilityLink({ car });

  return useMemo(
    () => ({
      context: {
        car,
        supplier: car.supplier,
        kind: getVehicleClassLabelFromVehicle(t, car.vehicle),
        name: car.vehicle.name,
        image: car.vehicle.images?.["original"],
        attributes: {
          passengersQuantity: car.vehicle.passengerQty,
          unlimitedMileage: car.hasUnlimitedMileage,
          baggageQuantity: getBaggageQty(car.vehicle),

          transmissionType: getVehicleTransmissionLabel(
            t,
            car.vehicle.transmissionType
          ),
          airConditioning: car.vehicle.airConditioning,
        },
        cancellationPolicy: car.cancellationPolicy,
        prices: props.car.totalCharge,
        searchDayCount,
        pickup: car.pickUp,
      },
      handlers: {
        goToShop,
      },
    }),
    [car, t, props.car.totalCharge, searchDayCount, goToShop]
  );
};
